import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { selectIsPiPAvailable } from '../../../../../settings';
import { Island } from '../../island';
import { DoNotCheckDesktopAppExistenceTumbler } from '../../tumblers';
import { PiPActiveTumbler } from '../../tumblers/pip-active-tumbler';
import css from './styles.css';

export const DevelopSection: FunctionComponent = () => {
    const isPiPAvailable = useSelector(selectIsPiPAvailable);

    return (
        <Island className={css.developWrapper}>
            <DoNotCheckDesktopAppExistenceTumbler />
            {isPiPAvailable && <PiPActiveTumbler />}
        </Island>
    );
};
